import { render, staticRenderFns } from "./InfoAthletes.vue?vue&type=template&id=7f3767ea&scoped=true"
import script from "./InfoAthletes.vue?vue&type=script&lang=js"
export * from "./InfoAthletes.vue?vue&type=script&lang=js"
import style0 from "./InfoAthletes.vue?vue&type=style&index=0&id=7f3767ea&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3767ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3767ea')) {
      api.createRecord('7f3767ea', component.options)
    } else {
      api.reload('7f3767ea', component.options)
    }
    module.hot.accept("./InfoAthletes.vue?vue&type=template&id=7f3767ea&scoped=true", function () {
      api.rerender('7f3767ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/InfoAthletes.vue"
export default component.exports